import { motion } from "framer-motion";

export default function Preloader() {
  return (
    <motion.div
      data-testid="preloader"
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#120d0b]"
      exit={{ clipPath: "inset(0 0 100% 0)", transition: { duration: 0.9, ease: [0.76, 0, 0.24, 1] } }}
    >
      <motion.img
        src="/images/logo.png"
        alt=""
        className="h-28 w-28 rounded-full border border-[#c9a24a]/40 object-cover"
        initial={{ opacity: 0, scale: 0.85 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      />
      <motion.p
        className="mt-8 font-display text-2xl uppercase tracking-[0.35em] text-[#f4ecdd]"
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.8 }}
      >
        Vintage Billard
      </motion.p>
      <motion.p
        className="mt-3 text-[10px] uppercase tracking-[0.3em] text-[#c9a24a]"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6, duration: 0.8 }}
      >
        Bremen · Hemelingen
      </motion.p>
      <motion.span
        className="mt-10 h-px bg-[#c9a24a]"
        initial={{ width: 0 }}
        animate={{ width: 120 }}
        transition={{ delay: 0.5, duration: 1.2, ease: "easeInOut" }}
      />
    </motion.div>
  );
}
